import { memo } from "react";
import { useTranslation } from "react-i18next";
import orderBackgroundEN from "../../../../assets/images/order_next_steps_info_english.png";
import orderBackgroundFR from "../../../../assets/images/order_next_steps_info_french.png";

import quoteBackgroundEN from "../../../../assets/images/quote_next_steps_info_english.png";
import quoteBackgroundFR from "../../../../assets/images/quote_next_steps_info_french.png";

import { Box } from "../../../../common/components";
import { Styles } from "../../../../styles/theme";

const styles: Styles = {
  container: {
    borderRadius: "4px",
    maxWidth: 400,
    minHeight: 201,
    "&>img": {
      maxWidth: 400,
      width: "100%",
    },
  },
};

interface Props {
  hasReachedMaximum: boolean;
}

const NextStepInfo = ({ hasReachedMaximum }: Props) => {
  const { i18n } = useTranslation();
  const quoteImage =
    i18n.language === "fr" ? quoteBackgroundFR : quoteBackgroundEN;
  const orderImage =
    i18n.language === "fr" ? orderBackgroundFR : orderBackgroundEN;
  const image = hasReachedMaximum ? quoteImage : orderImage;

  return (
    <Box sx={styles.container}>
      <img src={image} alt="Next step info" />
    </Box>
  );
};

export default memo(NextStepInfo);
